import { Component } from '@theme/component';

/**
 * A custom element that renders a video background.
 * Otimizacao 26/10: o video so e carregado quando o bloco chega perto da tela.
 *
 * @typedef {object} Refs
 * @property {HTMLElement[]} videoSources - The video sources.
 * @property {HTMLVideoElement} videoElement - The video element.
 *
 * @extends Component<Refs>
 */
export class VideoBackgroundComponent extends Component {
  requiredRefs = ['videoSources', 'videoElement'];

  /** @type {IntersectionObserver | null} */
  #observer = null;

  #loaded = false;

  connectedCallback() {
    super.connectedCallback();

    if (!('IntersectionObserver' in window)) {
      this.#loadVideo();
      return;
    }

    this.#observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          this.#observer?.disconnect();
          this.#observer = null;
          this.#loadVideo();
        }
      },
      { rootMargin: '300px 0px' }
    );

    this.#observer.observe(this);
  }

  disconnectedCallback() {
    super.disconnectedCallback?.();
    this.#observer?.disconnect();
    this.#observer = null;
  }

  #loadVideo() {
    if (this.#loaded) return;
    this.#loaded = true;

    const { videoSources, videoElement } = this.refs;

    for (const source of videoSources) {
      const { videoSource } = source.dataset;

      if (videoSource) source.setAttribute('src', videoSource);
    }

    videoElement.load();
  }
}

if (!customElements.get('video-background-component')) {
  customElements.define('video-background-component', VideoBackgroundComponent);
}
